import baseAPI from "@/http";

const router = "api/relatorio/relatorioGestaoPagamento";

export const paymentReportManagementAPI = {
  create: (paymentReport) =>
    baseAPI.post(`${router}/cadastrar-relatorio-pagamento`, paymentReport),
  update: (paymentReport) =>
    baseAPI.put(`${router}/atualizar-relatorio-pagamento`, paymentReport),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByUser: (filter) => baseAPI.post(`${router}/get-by-usuario`, filter),
  listByFilter: (filter) => baseAPI.post(`${router}/list-by-filtro`, filter),
  analyse: (paymentReport) =>
    baseAPI.put(`${router}` + "/analisar-relatorio", paymentReport),
  receiveEmail: (id) => baseAPI.get(`${router}/send-mail-sgf/${id}`),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  downloadAnexo: (relatorioAnexoId) =>
    baseAPI.post("api/arquivo/anexo/download/" + relatorioAnexoId, null, {
      responseType: "blob",
    }),
  downloadAnexoProcessoPagamento: (relatorioGestaoPagamentoAnexoId) =>
    baseAPI.post(
      "api/arquivo/anexo/download-processo-pagamento/" +
        relatorioGestaoPagamentoAnexoId,
      null,
      { responseType: "blob" }
    ),
  downloadGestaoPagamento: (id, permissaoTipo) =>
    baseAPI.get(`${router}/download-gestao-pagamento/${id}/${permissaoTipo}`, {
      responseType: "blob",
    }),
  downloadGestaoPagamentoSP: (id) =>
    baseAPI.get(`${router}/download-relatorio-prestacao-servico/${id}`, {
      responseType: "blob",
    }),
  getNumeroRelatorio: (id, contratoid, tipoSolucaoId) =>
    baseAPI.get(
      `${router}` +
        "/obter-numero-relatorio" +
        `/${id}/${contratoid}/${tipoSolucaoId}`
    ),
};
